/**
 * 2018 - Triad Berlin Projektgesellschaft mbH
 * 
 * @author Jan Bundschuh
 */

import $ from "jquery";

export default class Bonbon {
    /**
     * 
     * Der Konstruktor.
     * 
     * @param {*} id 
     * @param {*} data 
     * @param {*} parent 
     * @param {*} combination 
     */
    constructor(id, data, parent, combination, colors) {
        this.parent = parent ? parent : $('#bonbons');
        this.id = id;
        this.colors = colors;
        this.data = combination ? this.replaceColors(data, combination) : data;
        this.internalID = 'bon' + this.createID();
        let bonClass = '.bonbon' + id;

        let bonbon = $(this.data).find(bonClass);
        bonbon.attr('id', this.internalID);

        this.parent.append(bonbon);
        this.element = document.getElementById(this.internalID)
    }

    replaceColors(data, combination) {
        for (var i = 0; i < Math.min(combination.length, 6); i++) {
            let index = parseInt(combination[i]) - 1;
            data = data.split(('#color' + (i + 1))).join(this.colors[index]);
        }
        return data;
    }

    /**
     * Generate unique IDs for use as pseudo-private/protected names.
     * Similar in concept to
     * <http://wiki.ecmascript.org/doku.php?id=strawman:names>.
     */
    createID() {
        return '_' + Math.random().toString(36).substr(2, 9);
    }

    /**
     * 
     * @param {*} animateAndAutoRemove 
     * @param {*} offset 
     * @param {*} duration 
     */
    show(animateAndAutoRemove, offset, duration) {
        if (this.element) {
            offset = offset ? offset : [1025, 476];
            duration = duration ? duration : 300;
            var rand = Math.random() * 25;
            Velocity(this.element, { translateX: offset[0] - (36 * 0.5), translateY: offset[1] - (36 * 0.5) }, { duration: 0 });
            if (animateAndAutoRemove) {
                Velocity(this.element, { translateX: '+=' + (rand + 70) }, { duration: duration, queue: false, easing: 'linear' });
                Velocity(this.element, { translateY: '+=' + 32 }, { duration: duration, queue: false, easing: 'linear' });
                Velocity(this.element, { rotateZ: 90 + 'deg' }, { duration: duration, queue: false, easing: 'linear' });
                //Velocity(this.element, { opacity: 0 }, { duration: duration * 1.5, delay: duration * 3.0, queue: false, easing: 'linear' });
                Velocity(this.element, { translateX: '+=' + 250, 'opacity' : 0 }, { duration: duration * 4.5, delay: duration, queue: false, easing: 'linear', complete: () => { $('#' + this.internalID).remove() } });
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Bonbon.js